/**
 * @generated SignedSource<<e05c26c50783cb6f0539a6b386e0bf15>>
 * @relayHash f2f263803b888b693e0d2afd80d40e34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c43ecc6efa8d6d7ee2b042fd70d8e309c27eaeac76a5e4afef7176bad447778f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c43ecc6efa8d6d7ee2b042fd70d8e309c27eaeac76a5e4afef7176bad447778f",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
